<template>
  <div class="course-list-wrapper">
    <div class="course-list">
      <div
        class="course"
        v-for="(item, index) in courseList"
        :key="'course_' + index"
        @click="goDetail(item.courseId)"
      >
        <el-row :gutter="15">
          <el-col class="left" :span="4">
            <el-image
              class="cover"
              fit="contain"
              :src="item.coverUrl | setCourseCover"
            >
              <div slot="error" class="img-error">
                <img :src="require('@/assets/images/whkcsz/default_img.png')" />
              </div>
            </el-image>
          </el-col>
          <el-col class="right" :span="20">
            <div class="info-wrapper">
              <div class="title">{{ item.courseName }}</div>
              <div class="school">{{ item.schoolName }}</div>
              <div class="num">访问量：{{ item.viewCount | setViewCount }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/libs/util.js";
export default {
  name: "",
  props: {
    courseList: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  filters: {
    setCourseCover(src) {
      return util.setCourseCover(src);
    },
    setViewCount(count) {
      return util.setViewCount(count);
    },
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: `/whkcsz/courseDetail/${id}`
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../variables.scss";
.course-list-wrapper {
  .course-list {
    .course {
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: none;
      }
      .left {
        width: 150px;
        height: 76px;
        .el-image {
          width: 100%;
          height: 100%;
          .iconfont {
            width: 40px;
            height: 40px;
            font-size: 40px;
          }
        }
      }
      .right {
        width: calc(100% - 150px);
        .title {
          margin-bottom: 4px;
          font-size: 14px;
          line-height: 20px;
          @include ellipse-two(100%, 40px);
        }
        .school,
        .num {
          font-size: 12px;
          color: #969696;
          line-height: 16px;
        }
      }
    }
  }
}
</style>